__turbopack_context__.v({
  "accentBullets": "page-module__E0kJGG__accentBullets",
  "active": "page-module__E0kJGG__active",
  "badge": "page-module__E0kJGG__badge",
  "badgeDot": "page-module__E0kJGG__badgeDot",
  "blink": "page-module__E0kJGG__blink",
  "btnCtaGhost": "page-module__E0kJGG__btnCtaGhost",
  "btnNav": "page-module__E0kJGG__btnNav",
  "btnPriceOutline": "page-module__E0kJGG__btnPriceOutline",
  "btnPricePrimary": "page-module__E0kJGG__btnPricePrimary",
  "btnPrimary": "page-module__E0kJGG__btnPrimary",
  "carouselTrack": "page-module__E0kJGG__carouselTrack",
  "carouselTrackWrap": "page-module__E0kJGG__carouselTrackWrap",
  "ck": "page-module__E0kJGG__ck",
  "ctaBtns": "page-module__E0kJGG__ctaBtns",
  "ctaCard": "page-module__E0kJGG__ctaCard",
  "ctaSection": "page-module__E0kJGG__ctaSection",
  "customBanner": "page-module__E0kJGG__customBanner",
  "customBannerActions": "page-module__E0kJGG__customBannerActions",
  "customBannerImage": "page-module__E0kJGG__customBannerImage",
  "customBannerOverlay": "page-module__E0kJGG__customBannerOverlay",
  "customBannerSub": "page-module__E0kJGG__customBannerSub",
  "customBannerTitle": "page-module__E0kJGG__customBannerTitle",
  "darkBullets": "page-module__E0kJGG__darkBullets",
  "demoCard": "page-module__E0kJGG__demoCard",
  "demoCardLabel": "page-module__E0kJGG__demoCardLabel",
  "demoCardSvg": "page-module__E0kJGG__demoCardSvg",
  "demoCardText": "page-module__E0kJGG__demoCardText",
  "demoCardValue": "page-module__E0kJGG__demoCardValue",
  "demoCards": "page-module__E0kJGG__demoCards",
  "diIcon": "page-module__E0kJGG__diIcon",
  "divider": "page-module__E0kJGG__divider",
  "dotFill": "page-module__E0kJGG__dotFill",
  "faqBody": "page-module__E0kJGG__faqBody",
  "faqBtn": "page-module__E0kJGG__faqBtn",
  "faqEyebrow": "page-module__E0kJGG__faqEyebrow",
  "faqH2": "page-module__E0kJGG__faqH2",
  "faqIcon": "page-module__E0kJGG__faqIcon",
  "faqItem": "page-module__E0kJGG__faqItem",
  "faqLink": "page-module__E0kJGG__faqLink",
  "faqList": "page-module__E0kJGG__faqList",
  "faqSection": "page-module__E0kJGG__faqSection",
  "faqSectionHeader": "page-module__E0kJGG__faqSectionHeader",
  "fc1": "page-module__E0kJGG__fc1",
  "fc2": "page-module__E0kJGG__fc2",
  "fc3": "page-module__E0kJGG__fc3",
  "fc4": "page-module__E0kJGG__fc4",
  "fc5": "page-module__E0kJGG__fc5",
  "fc6": "page-module__E0kJGG__fc6",
  "featCardText": "page-module__E0kJGG__featCardText",
  "featDot": "page-module__E0kJGG__featDot",
  "featOverlay": "page-module__E0kJGG__featOverlay",
  "featureCard": "page-module__E0kJGG__featureCard",
  "featuresControls": "page-module__E0kJGG__featuresControls",
  "featuresDots": "page-module__E0kJGG__featuresDots",
  "featuresPauseBtn": "page-module__E0kJGG__featuresPauseBtn",
  "featuresSection": "page-module__E0kJGG__featuresSection",
  "featuresSectionInner": "page-module__E0kJGG__featuresSectionInner",
  "featuresTrack": "page-module__E0kJGG__featuresTrack",
  "featuresTrackWrapper": "page-module__E0kJGG__featuresTrackWrapper",
  "footer": "page-module__E0kJGG__footer",
  "footerBottom": "page-module__E0kJGG__footerBottom",
  "footerCol": "page-module__E0kJGG__footerCol",
  "footerGrid": "page-module__E0kJGG__footerGrid",
  "footerInner": "page-module__E0kJGG__footerInner",
  "footerSocial": "page-module__E0kJGG__footerSocial",
  "hero": "page-module__E0kJGG__hero",
  "heroCta": "page-module__E0kJGG__heroCta",
  "heroFog": "page-module__E0kJGG__heroFog",
  "heroH1": "page-module__E0kJGG__heroH1",
  "heroIntLabel": "page-module__E0kJGG__heroIntLabel",
  "heroIntSub": "page-module__E0kJGG__heroIntSub",
  "heroIntTitle": "page-module__E0kJGG__heroIntTitle",
  "heroSub": "page-module__E0kJGG__heroSub",
  "heroSubStrong": "page-module__E0kJGG__heroSubStrong",
  "heroTextLayer": "page-module__E0kJGG__heroTextLayer",
  "heroVideoBg": "page-module__E0kJGG__heroVideoBg",
  "heroVideoOverlay": "page-module__E0kJGG__heroVideoOverlay",
  "howItWorksInner": "page-module__E0kJGG__howItWorksInner",
  "howItWorksSection": "page-module__E0kJGG__howItWorksSection",
  "industriesSection": "page-module__E0kJGG__industriesSection",
  "intCard": "page-module__E0kJGG__intCard",
  "intIcon": "page-module__E0kJGG__intIcon",
  "intName": "page-module__E0kJGG__intName",
  "intSection": "page-module__E0kJGG__intSection",
  "lgText": "page-module__E0kJGG__lgText",
  "navCaret": "page-module__E0kJGG__navCaret",
  "navDropdown": "page-module__E0kJGG__navDropdown",
  "navDropdownToggle": "page-module__E0kJGG__navDropdownToggle",
  "navDropdownWrap": "page-module__E0kJGG__navDropdownWrap",
  "navLinks": "page-module__E0kJGG__navLinks",
  "navLoadingPlaceholder": "page-module__E0kJGG__navLoadingPlaceholder",
  "navLogin": "page-module__E0kJGG__navLogin",
  "navLogo": "page-module__E0kJGG__navLogo",
  "navLogoImg": "page-module__E0kJGG__navLogoImg",
  "navRight": "page-module__E0kJGG__navRight",
  "novaNav": "page-module__E0kJGG__novaNav",
  "open": "page-module__E0kJGG__open",
  "overageNote": "page-module__E0kJGG__overageNote",
  "pageWrapper": "page-module__E0kJGG__pageWrapper",
  "paused": "page-module__E0kJGG__paused",
  "planDesc": "page-module__E0kJGG__planDesc",
  "planTitle": "page-module__E0kJGG__planTitle",
  "priceCard": "page-module__E0kJGG__priceCard",
  "priceCardCustom": "page-module__E0kJGG__priceCardCustom",
  "priceCardCustomLeft": "page-module__E0kJGG__priceCardCustomLeft",
  "priceCardCustomNote": "page-module__E0kJGG__priceCardCustomNote",
  "priceCardCustomPrice": "page-module__E0kJGG__priceCardCustomPrice",
  "priceCardCustomRight": "page-module__E0kJGG__priceCardCustomRight",
  "priceDetailsItems": "page-module__E0kJGG__priceDetailsItems",
  "priceDetailsLabel": "page-module__E0kJGG__priceDetailsLabel",
  "priceDivider": "page-module__E0kJGG__priceDivider",
  "priceFeatures": "page-module__E0kJGG__priceFeatures",
  "pricingGrid": "page-module__E0kJGG__pricingGrid",
  "pricingSection": "page-module__E0kJGG__pricingSection",
  "scrollLeft": "page-module__E0kJGG__scrollLeft",
  "sectionHeader": "page-module__E0kJGG__sectionHeader",
  "sectionHeaderNarrow": "page-module__E0kJGG__sectionHeaderNarrow",
  "sectionInner": "page-module__E0kJGG__sectionInner",
  "sectionSpacer": "page-module__E0kJGG__sectionSpacer",
  "showcaseGrid": "page-module__E0kJGG__showcaseGrid",
  "showcaseHeaderRow": "page-module__E0kJGG__showcaseHeaderRow",
  "showcaseTile": "page-module__E0kJGG__showcaseTile",
  "stars": "page-module__E0kJGG__stars",
  "step": "page-module__E0kJGG__step",
  "step01Img": "page-module__E0kJGG__step01Img",
  "step01ImgWrapper": "page-module__E0kJGG__step01ImgWrapper",
  "step02Robot": "page-module__E0kJGG__step02Robot",
  "step03": "page-module__E0kJGG__step03",
  "step03Img": "page-module__E0kJGG__step03Img",
  "step03ImgCol": "page-module__E0kJGG__step03ImgCol",
  "step03Left": "page-module__E0kJGG__step03Left",
  "step04": "page-module__E0kJGG__step04",
  "step04Img": "page-module__E0kJGG__step04Img",
  "step04ImgCol": "page-module__E0kJGG__step04ImgCol",
  "step04Left": "page-module__E0kJGG__step04Left",
  "step04Overlay": "page-module__E0kJGG__step04Overlay",
  "stepFinale": "page-module__E0kJGG__stepFinale",
  "stepHero": "page-module__E0kJGG__stepHero",
  "stepList": "page-module__E0kJGG__stepList",
  "stepNum": "page-module__E0kJGG__stepNum",
  "steps": "page-module__E0kJGG__steps",
  "stepsRight": "page-module__E0kJGG__stepsRight",
  "stepsRightTop": "page-module__E0kJGG__stepsRightTop",
  "tileActions": "page-module__E0kJGG__tileActions",
  "tileBtnGhost": "page-module__E0kJGG__tileBtnGhost",
  "tileBtnPrimary": "page-module__E0kJGG__tileBtnPrimary",
  "tileDark": "page-module__E0kJGG__tileDark",
  "tileDeep": "page-module__E0kJGG__tileDeep",
  "tileLabel": "page-module__E0kJGG__tileLabel",
  "tileNavy": "page-module__E0kJGG__tileNavy",
  "tileSlate": "page-module__E0kJGG__tileSlate",
  "tileSub": "page-module__E0kJGG__tileSub",
  "tileTitle": "page-module__E0kJGG__tileTitle",
  "tileVisual": "page-module__E0kJGG__tileVisual",
  "trialBadge": "page-module__E0kJGG__trialBadge",
});
